<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Share Your Guidebook'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <form [formGroup]="itemForm" novalidate action="#">
        <div class="wizard-progress-bar">
          <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
        </div>

        @if (currentStep === 1) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Share Your Guidebook'" />
          </div>

          <div class="wizard-cards">
            <tidy-card
              class="wizard-card"
              (click)="selectShareMethod('url')">
              <div class="wizard-card-radio">
                <span class="wizard-card-radio-inner"></span>
              </div>
              <div class="wizard-card-text">
                <tidy-text [body]="'Share URL'" />
                <tidy-text [helper]="'Provide a link to your guidebook.'" />
              </div>
            </tidy-card>

            <tidy-card
              class="wizard-card"
              (click)="selectShareMethod('upload')">
              <div class="wizard-card-radio">
                <span class="wizard-card-radio-inner"></span>
              </div>
              <div class="wizard-card-text">
                <tidy-text [body]="'Upload File'" />
                <tidy-text [helper]="'Upload your guidebook as a file.'" />
              </div>
            </tidy-card>
          </div>
        }

        @if (currentStep === 2) {
          @if (itemForm.value.shareMethod === 'url') {
            <div class="wizard-step-header">
              <tidy-text [title]="'Share Guidebook URL'" />
            </div>
            <div class="wizard-content">
              <tidy-row>
                <tidy-input
                  [label]="'Guidebook URL'"
                  formControlName="url"
                  [form]="itemForm.controls.url"
                  [icon]="'assets/svg/globe-outline.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a URL'" />
              </tidy-row>
            </div>
            <div class="wizard-nav-row wizard-content">
              <tidy-button
                [text]="'Next'"
                [action]="goToNextStep"
                class="primary" />
            </div>
          }

          @if (itemForm.value.shareMethod === 'upload') {
            <div class="wizard-step-header">
              <tidy-text [title]="'Upload Guidebook'" />
            </div>
            <tidy-card class="wizard-content">
              <tidy-row>
                <tidy-pill-button
                  [image]="'assets/svg/cloud-upload-outline.svg'"
                  [text]="'Upload Guidebook'"
                  (buttonClick)="addAttachment()" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'We can handle one or multiple files of any type.'" />
              </tidy-row>
              @if (attachments.length) {
                <tidy-row class="extra-top-padding extra-bottom-padding">
                  @for (attachment of attachments; track attachment.fileKey; let i = $index) {
                    <tidy-row>
                      <tidy-text
                        [body]="attachment.filename" /><span>&nbsp;</span>
                      <tidy-text
                        [actionBody]="'remove'"
                        (action)="removeAttachment(i)"
                        class="red link" />
                    </tidy-row>
                  }
                </tidy-row>
              }
            </tidy-card>
            <div class="wizard-nav-row wizard-content">
              <tidy-button
                [text]="'Next'"
                [action]="goToNextStep"
                class="primary" />
            </div>
          }
        }

        @if (currentStep === 3) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Notes for Concierge (Optional)'" />
          </div>
          <div class="wizard-content">
            <tidy-row>
              <tidy-textarea
                [label]="'Anything we should know about your guidebook?'"
                [icon]="'assets/svg/create.svg'"
                [form]="itemForm.controls.body"
                formControlName="body" />
            </tidy-row>

            <div class="wizard-nav-row">
              <tidy-button
                [text]="'Finish'"
                [action]="finish"
                class="primary" />
            </div>
          </div>
        }
      </form>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
